import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [learnOpen, setLearnOpen] = useState(false);
  const location = useLocation();
  const dropdownRef = useRef(null);

  const learnLinks = [
    { to: '/stock-market-fundamentals', label: 'Stock Market Fundamentals' },
    { to: '/investment-basics',         label: 'Investment Basics' },
    { to: '/trading-principles',        label: 'Trading Principles' },
    { to: '/risk-management',           label: 'Risk Management' },
    { to: '/market-analysis',           label: 'Market Analysis' },
    { to: '/trading-platforms',         label: 'Trading Platforms' },
  ];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClick = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setLearnOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  // Close everything on route change
  useEffect(() => {
    setMobileOpen(false);
    setLearnOpen(false);
  }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="sf-navbar">
      <div className="container">
        {/* Brand */}
        <Link to="/" className="sf-brand">
          <img src="/logo.png" alt="StckFuture" onError={(e) => { e.target.style.display = 'none'; }} />
          <span className="sf-brand-dot"></span>
          StckFuture
        </Link>

        {/* Desktop nav */}
        <ul className="sf-nav-links">
          <li>
            <Link
              to="/"
              className={`nav-link ${isActive('/') ? 'active' : ''}`}
            >
              Home
            </Link>
          </li>

          {/* Learn dropdown */}
          <li className={`sf-dropdown ${learnOpen ? 'open' : ''}`} ref={dropdownRef}>
            <span
              className="nav-link sf-dropdown-toggle"
              onClick={() => setLearnOpen(!learnOpen)}
              role="button"
              aria-expanded={learnOpen}
            >
              Learn
            </span>
            <div className="sf-dropdown-menu">
              {learnLinks.map((l) => (
                <Link key={l.to} to={l.to}>{l.label}</Link>
              ))}
            </div>
          </li>

          <li>
            <Link
              to="/glossary"
              className={`nav-link ${isActive('/glossary') ? 'active' : ''}`}
            >
              Glossary
            </Link>
          </li>
          <li>
            <Link
              to="/quiz"
              className={`nav-link ${isActive('/quiz') ? 'active' : ''}`}
            >
              Quiz
            </Link>
          </li>
          <li>
            <a
              href="https://join.robinhood.com/christm6689"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link sf-nav-cta"
            >
              Start Investing
            </a>
          </li>
        </ul>

        {/* Mobile hamburger */}
        <button
          className="sf-hamburger"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`sf-mobile-menu ${mobileOpen ? 'open' : ''}`}>
        <Link to="/">Home</Link>
        {learnLinks.map((l) => (
          <Link key={l.to} to={l.to}>{l.label}</Link>
        ))}
        <Link to="/glossary">Glossary</Link>
        <Link to="/quiz">Quiz</Link>
        <a
          href="https://join.robinhood.com/christm6689"
          target="_blank"
          rel="noopener noreferrer"
          className="sf-mobile-cta"
        >
          Start Investing
        </a>
      </div>
    </nav>
  );
};

export default Navbar;